import cx from "classnames";
import { useContext } from "react";
import StuntDriversContext from "./StuntDriversContext.jsx";
import StuntDriversNavigationGraphic from "./StuntDriversNavigationGraphic.jsx";

const propTypes = {};

const StuntDriversNavigation = (props) => {
  const {
    activeCategoryId,
    activeSectionId,
    currentCategory,
    currentSection,
    handleSelect,
  } = useContext(StuntDriversContext);

  if (!currentCategory || (!activeCategoryId && !activeSectionId)) return null;

  return (
    <div
      className={cx("stunt-drivers__navigation", {
        "stunt-drivers__navigation--no-item-selected": !activeSectionId,
        "stunt-drivers__navigation--no-sections": !currentCategory.sections,
      })}
    >
      <div className="stunt-drivers__navigation-graphic">
        <StuntDriversNavigationGraphic />
      </div>
      <div className="stunt-drivers__navigation-content">
        <div className="stunt-drivers__navigation-header">
          <h2 className="stunt-drivers__navigation-title">
            {currentCategory.name}
          </h2>
          <div className="stunt-drivers__navigation-icon">
            <img src={currentCategory.icon} alt="Icon" />
          </div>
        </div>

        {currentCategory.sections && (
          <ul className="stunt-drivers__navigation-sections">
            {currentCategory.sections.map((item, index) => {
              return (
                <li key={index}>
                  {item.isEnabled && activeSectionId ? (
                    <a
                      className={cx({
                        active:
                          item.id === (currentSection && currentSection.id),
                      })}
                      onClick={() => handleSelect(activeCategoryId, index + 1)}
                    >
                      {item.title}
                    </a>
                  ) : (
                    <span>{item.title}</span>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

StuntDriversNavigation.propTypes = propTypes;
export default StuntDriversNavigation;
